import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Box,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { ReactNode, useState } from "react";

interface InfoAccordionProps {
  title: string;
  children: ReactNode;
  defaultExpanded?: boolean;
  sx?: object;
}

const InfoAccordion: React.FC<InfoAccordionProps> = ({
  title,
  children,
  defaultExpanded = false,
  sx = {},
}) => {
  const [expanded, setExpanded] = useState(defaultExpanded);

  return (
    <Accordion
      expanded={expanded}
      onChange={(_, isExpanded) => setExpanded(isExpanded)}
      sx={{
        backgroundColor: "rgba(2, 136, 209, 0.08)",
        border: "1px solid rgba(2, 136, 209, 0.3)",
        borderRadius: "4px !important",
        "&:before": { display: "none" },
        boxShadow: "none",
        ...sx,
      }}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon sx={{ color: "info.main" }} />}
        sx={{
          minHeight: 48,
          "&.Mui-expanded": { minHeight: 48 },
          "& .MuiAccordionSummary-content": {
            margin: "12px 0",
            "&.Mui-expanded": { margin: "12px 0" },
          },
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <InfoOutlinedIcon sx={{ color: "info.main", fontSize: 20 }} />
          <Typography variant="body2" sx={{ fontWeight: 600, color: "info.main" }}>
            {title}
          </Typography>
        </Box>
      </AccordionSummary>
      <AccordionDetails sx={{ pt: 0, pb: 2 }}>
        <Box sx={{ color: "text.secondary" }}>{children}</Box>
      </AccordionDetails>
    </Accordion>
  );
};

export default InfoAccordion;
